import { FeedItems } from "@components/Tags/TagNonprofitsTab";
import { NextPage } from "next";

import { TagPage } from "src/pages/Tags/Tags";
import { createGetServerSideProps } from "src/utilities/ssr/createGetServerSideProps";
import { getCauseServerSideProps } from "src/utilities/ssr/getCauseServerSideProps";
import { withPropsDeserialization } from "src/utilities/ssr/withPropsDeserialization";

export const getServerSideProps = createGetServerSideProps(
  getCauseServerSideProps
);

const CausePageExport: NextPage<{
  tagName: string;
  feedItems?: FeedItems;
}> = ({ tagName, feedItems }) => {
  return <TagPage tagName={tagName} initialFeedItems={feedItems} />;
};

export default withPropsDeserialization(CausePageExport);
